import React from 'react'
import { Check, CrossIcon } from 'chemistry'

const badContentRegExp = /<!-*>/
export default function (collection) {
  return collection.filter(item => isNaN(item)).filter(item => !badContentRegExp.test(item))
}

const NEGATIVE_MARK = 'NEGATIVE_MARK'
const POSITIVE_MARK = 'POSITIVE_MARK'

const MARK_STATES = {
  ja: POSITIVE_MARK,
  yes: POSITIVE_MARK,
  oui: POSITIVE_MARK,
  true: POSITIVE_MARK,

  non: NEGATIVE_MARK,
  neen: NEGATIVE_MARK,
  nee: NEGATIVE_MARK,
  no: NEGATIVE_MARK,
  false: NEGATIVE_MARK
}

const heightVar = 'calc(1em * var(--chakra-lineHeights-base))'
export const mark = value => {
  if (value === POSITIVE_MARK) return <Check height={heightVar} width={heightVar} />
  return <CrossIcon height={heightVar} width={heightVar} color='red.primary' />
}

export const buildAttributeValue = attribute => {
  let { unit, value } = attribute
  const markValue = MARK_STATES[value.toLowerCase()]
  if (markValue) return mark(markValue)
  if (value && !isNaN(value)) value = parseFloat(value).toString()
  if (!unit) return value
  return `${value} ${unit}`
}
